import { IPlayer } from '../../user/store';

export interface IPlayerProfile extends IPlayer {
  events: number[];
}

export interface IPlayerProfileStore {
  [playerId: number]: IPlayerProfile;
}

export const playerProfileStore: IPlayerProfileStore = {};
